import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isNumberInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.NUMBER_INPUT && typeof label === 'string' && (typeof value === 'number' || value === null);
}
function _formatNumberInput(_ref) {
  let {
    field,
    value
  } = _ref;
  if (typeof value !== 'number') {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatNumberInput(submission) {
  if (isNumberInput(submission)) {
    return _formatNumberInput(submission);
  }
  return undefined;
}
//# sourceMappingURL=number-input-preview.js.map